var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function CE(tagName, props, children, event) {
    const tag = document.createElement(tagName);
    for (const key in props) {
        if (Object.prototype.hasOwnProperty.call(props, key)) {
            tag.setAttribute(key, props[key]);
        }
    }
    if (children) {
        for (const e of children) {
            if (!e)
                continue;
            if ("string" === typeof e) {
                tag.appendChild(document.createTextNode(e));
            }
            else {
                tag.appendChild(e);
            }
        }
    }
    if (event) {
        for (const key in event) {
            if (Object.prototype.hasOwnProperty.call(event, key)) {
                const lis = event[key];
                tag.addEventListener(key, lis);
            }
        }
    }
    return tag;
}
export function sleep(sleepTime) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, sleepTime);
        });
    });
}
;
